// extracted by mini-css-extract-plugin
export default {"arrow":"Arrows_arrow__eWznz","invisible":"Arrows_invisible__oOU94"};